import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "components/Header/Header.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import BottomNavSection from "./../TenPage/Sections/BottomNavSection.jsx";
import FooterSection from "./../PortalPage/Sections/FooterSection.jsx";

import { API } from 'aws-amplify';

import cataloguePageStyle from "assets/jss/material-kit-pro-react/views/cataloguePageStyle.jsx";
import CapExResWelcomeSection from "./Sections/CapExResWelcomeSection.jsx";
import CapExResBarChartSection from "./Sections/CapExResBarChartSection.jsx";
import CapExResChartSection from "./Sections/CapExResChartSection.jsx";
import CapExResDetailsSection from "./Sections/CapExResDetailsSection.jsx";
import CapExResRecommendationsSection from "./Sections/CapExResRecommendationsSection.jsx";
import CapExResSummarySection from "./Sections/CapExResSummarySection.jsx";

class CapExplorerResultsPage extends React.Component {

  state = {
    answers: [],
    answersPerDomain: {
      D1: [],
      D2: [],
      D3: [],
      D4: [],
      D5: [],
      D6: [],
      D7: []
    },
    actor: {
      name: null,
      mbox: null
    },
    completion: null,
    results: [],
    recommendations: [],
    timestamp: null,
    started: null
  };

  async getData() {
    const submissionIdParam = this.props.match.params.submissionId;
    let apiName = 'capabilityexplorer';
    // let path = '/capabilityexplorer/details/5cdd0a233aadaf062fd4840c';
    let path = '/capabilityexplorer/details/' + submissionIdParam;
    let myInit = { // OPTIONAL
      headers: {} // OPTIONAL
    };
    return await API.get(apiName, path, myInit);
  }

  componentDidMount() {
    let statements = this.getData().then(response => {
      // console.log('statements', statements);
      console.log("statements", response.data);
      this.setState({
        completion: response.data.completion,
        answers: response.data.answers,
        answersPerDomain: response.data.answersPerDomain,
        actor: {
          name: response.data.completion.statement.actor.name,
          mbox: response.data.completion.statement.actor.mbox
        },
        results: response.data.results,
        recommendations: response.data.recommendations,
        timestamp: response.data.completion.statement.timestamp,
        started: response.data.started.statement.timestamp
      });
    });
  }

  render() {
    const { classes, ...rest } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );
    const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
    // const statements = this.state.statements.map(statement => {
    //   return <div>{answers.statement.actor.mbox}</p>;
    // });
    return (
      <div>
        <Header
          color="transparent"
          brand="TEN Gateway"
          links={<HeaderLinks dropdownHoverColor="primary" />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "primary"
          }}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/books-shelves.jpeg")} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                  <div className={classes.profile}>
                    <div className={classes.name}>
                      <h1 className={classes.title}>
                        Capability Explorer Results
                      </h1>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              <CapExResWelcomeSection
                actor={this.state.actor}
                timestamp={this.state.timestamp}
                started={this.state.started}
              />
              <CapExResSummarySection results={this.state.results} />
              <CapExResRecommendationsSection
                recommendations={this.state.recommendations}
              />
              <CapExResDetailsSection
                answers={this.state.answers}
                results={this.state.results}
              />
              <BottomNavSection />
            </div>
          </div>
        </div>
        <FooterSection />
      </div>
    );
  }
}

export default withStyles(cataloguePageStyle)(CapExplorerResultsPage);
